import { AccommodationSelectorItemFragment } from "@graphql";

export type Accommodation = AccommodationSelectorItemFragment;

// accommodation id
export type Value = { accommodationId: string; offerId: string };

export type SearchFilter = {
  text: string;
};

export const initialFilter: SearchFilter = {
  text: ""
};

export interface Props {
  clearable?: boolean; // true by default
  disabled?: boolean;
  disabledFilterFields?: Array<keyof SearchFilter>;
  error?: string;
  fullWidth?: boolean;
  helperText?: React.ReactNode;
  initialFilter?: SearchFilter;
  invisible?: boolean; // don't render input control
  label?: string;
  onChange: (v: Accommodation | null) => void;
  required?: boolean;
  value?: Value;
}

export type AccommodationSelectorValueProps = {
  clearable: boolean;
  disabled: boolean;
  onClear: () => void;
  onOpen: () => void;
  value: Value;
};
